import { render, staticRenderFns } from "./CabinetTransfer.vue?vue&type=template&id=1b693a56&scoped=true&"
import script from "./CabinetTransfer.vue?vue&type=script&lang=js&"
export * from "./CabinetTransfer.vue?vue&type=script&lang=js&"
import style0 from "./CabinetTransfer.vue?vue&type=style&index=0&id=1b693a56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b693a56",
  null
  
)

export default component.exports